import { useSelector } from "react-redux";
import { RootState } from "@store/store";

/**
 * Whether the currently selected patient is allowed to request extra time
 * during a cognitive game (caregiver-controlled toggle).
 */
export function useInGameMoreTimeAllowed(): boolean {
  const selectedPatient = useSelector(
    (state: RootState) => state.home.selectedPatient
  );
  return selectedPatient?.inGameMoreTimeAllowed === true;
}
